// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/cpaImg/cpa_1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/cpaImg/cpa_2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/cpaImg/cpa_3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/cpaImg/cpa_4.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* CPA */
.servicenavbar {
  position: relative;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  top: -100px;
  width: 100%;
}

.servicesq {
  display: flex;
  flex-direction: column;
  width: 250px;
  height: 250px;
  background-color: var(--primary_color);
  color: white;
  font-size: 5rem;
  text-align: center;
  justify-content: center;
}

.secsub {
  font-size: 2rem;
}

@media (max-width: 1200px) {
  .servicesq {
    width: 200px;
    height: 200px;
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .secsub {
    font-size: 1rem;
  }
}
/* cpaSubNav */
.cpasubnav {
  display: flex;
  font-size: 1rem;
  justify-content: space-around;
  padding-bottom: 50px;
  padding-top: 50px;
  margin-bottom: 70px;
  text-align: center;
  align-items: center;
}

@media (max-width: 600px) {
  .cpasubnav {
    display: none;
  }
}
.cpasubnav a:hover {
  text-decoration: none;
  color: #cacaca;
}

.cpasubnav a:link {
  text-decoration: none;
  color: #ffffff;
}

.cpasubnav a:active {
  text-decoration: none;
  color: #6e6e6e;
}

.cpasubnav a:visited {
  text-decoration: none;
  color: #ffffff;
}

.whycpa {
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

.sixsq {
  width: 300px;
  height: 300px;
  background-color: var(--primary_color);
  color: white;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.sixsq img {
  width: 180px;
  height: 180px;
}

@media (max-width: 1200px) {
  .sixsq {
    margin-bottom: 2rem;
  }
}
/* USCPA 有助生涯&職涯規劃 */
.cpaappliance {
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 250px;
  height: 400px;
  overflow: hidden;
  border-radius: 1.5rem;
  margin-bottom: 50px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3), 0 2px 2px rgba(0, 0, 0, 0.3), 0 4px 4px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.3), 0 16px 16px rgba(0, 0, 0, 0.3);
}
.cpaappliance img {
  width: 400px;
}

@media (max-width: 1200px) {
  .cpaappliancearea {
    align-items: center;
    flex-direction: column;
    width: 100%;
  }
}
.cpaappliance:nth-child(1):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.cpaappliance:nth-child(2):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.cpaappliance:nth-child(3):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.cpaappliance:nth-child(4):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.sqtitle {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: #ffffff;
}

.sqdes {
  font-family: var(--font-serif);
  font-size: 1rem;
  font-style: italic;
  line-height: 1.35;
  text-align: left;
  margin-top: 30px;
  color: #ffffff;
}

.cpaappliance:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-size: cover;
  background-position: 0 0;
  transition: transform calc(var(--f) * 1.5) var(--g);
  pointer-events: none;
}

.cpaappliance:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200%;
  pointer-events: none;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.009) 11.7%, rgba(0, 0, 0, 0.034) 22.1%, rgba(0, 0, 0, 0.072) 31.2%, rgba(0, 0, 0, 0.123) 39.4%, rgba(0, 0, 0, 0.182) 46.6%, rgba(0, 0, 0, 0.249) 53.1%, rgba(0, 0, 0, 0.32) 58.9%, rgba(0, 0, 0, 0.394) 64.3%, rgba(0, 0, 0, 0.468) 69.3%, rgba(0, 0, 0, 0.54) 74.1%, rgba(0, 0, 0, 0.607) 78.8%, rgba(0, 0, 0, 0.668) 83.6%, rgba(0, 0, 0, 0.721) 88.7%, rgba(0, 0, 0, 0.762) 94.1%, rgba(0, 0, 0, 0.79) 100%);
  transform: translateY(-50%);
  transition: transform calc(var(--f) * 2) var(--g);
}

.sqcontent {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 125px 50px 50px 50px;
  transition: transform var(--f) var(--g);
  z-index: 1;
}

@media (hover: hover) and (min-width: 600px) {
  .cpaappliance:after {
    transform: translateY(0);
  }
  .sqcontent {
    transform: translateY(calc(100% - 15rem));
  }
  .sqcontent > *:not(.title) {
    opacity: 0;
    transform: translateY(1rem);
    transition: transform var(--f) var(--g), opacity var(--f) var(--g);
  }
  .cpaappliance:hover,
  .cpaappliance:focus-within {
    align-items: center;
  }
  .cpaappliance:hover:before,
  .cpaappliance:focus-within:before {
    transform: translateY(-4%);
  }
  .cpaappliance:hover:after,
  .cpaappliance:focus-within:after {
    transform: translateY(-50%);
  }
  .cpaappliance:hover .sqcontent,
  .cpaappliance:focus-within .sqcontent {
    transform: translateY(0);
  }
  .cpaappliance:hover .sqcontent > *:not(.title),
  .cpaappliance:focus-within .sqcontent > *:not(.title) {
    opacity: 1;
    transform: translateY(0);
    transition-delay: calc(var(--f) / 8);
  }
  .cpaappliance:focus-within:before, .card:focus-within:after,
  .cpaappliance:focus-within .sqcontent,
  .cpaappliance:focus-within .sqcontent > *:not(.title) {
    transition-duration: 0s;
  }
}
/* 考試科目與題型配比 */
.examtable {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.examsubjects {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  color: white;
}

.examtable {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 80px;
}

@media (max-width: 1200px) {
  .examtable {
    grid-template-columns: 1fr;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    width: 75%;
  }
}
.examsubjects img {
  width: 30%;
}

.subjectname {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 4rem;
}

.fullname {
  font-size: 1rem;
  line-height: 1.4rem;
  height: 2rem;
}

.chmean {
  font-size: 1rem;
  line-height: 1.4rem;
  height: 4rem;
  margin: 0 8%;
}

.des {
  font-size: 1rem;
  line-height: 1.4rem;
  margin: 0 10% 10% 10%;
  text-align: center;
}

.examtime {
  font-size: 1rem;
  text-align: center;
  line-height: 3rem;
  height: 3rem;
  width: 100%;
}

.qutype {
  width: 100%;
  line-height: 1.8rem;
  height: 11rem;
  font-size: 1rem;
  padding: 1rem;
}

.qutype span {
  display: block;
  float: left;
}

.qutype ul {
  padding: 0;
}

.qutype li {
  list-style: none;
  border-bottom: rgba(255, 255, 255, 0.2941176471) 1px solid;
  clear: both;
}

.qutype li .mma {
  width: 80%;
  padding-right: 5%;
}

.qutype li .mmt {
  width: 15%;
  text-align: right;
  margin-right: 5%;
}

/* bgcolor */
.fr {
  background-color: #0c4a83;
}

.tfr {
  background-color: #0a4072;
}

.mfr {
  background-color: #072c4e;
}

.bc {
  background-color: #ff8546;
}

.tbc {
  background-color: #ff732b;
}

.mbc {
  background-color: #ff6211;
}

.rg {
  background-color: #866579;
}

.trg {
  background-color: #69505f;
}

.mrg {
  background-color: #4d3a45;
}

.au {
  background-color: #d96939;
}

.tau {
  background-color: #b1562f;
}

.mau {
  background-color: #884224;
}

.br {
  background-color: #1f6e84;
}

.ic {
  background-color: #e09428;
}

.tp {
  background-color: #a647a5;
}

.tbr {
  background-color: #1a5c6e;
}

.tic {
  background-color: #c48123;
}

.ttp {
  background-color: #883987;
}

.mbr {
  background-color: #123e4b;
}

.mic {
  background-color: #a16a1d;
}

.mtp {
  background-color: #692d68;
}

.wt {
  background-color: #fff;
}

.gr {
  background-color: #f7f7f7;
}

.tsti {
  background-color: #333;
  color: #fff;
}

/* 四科考試架構及考試注意事項 */
.tmxl {
  width: 80%;
  border-right: 1px solid #fff;
}

.tms {
  width: 15%;
}

.tml {
  width: 45%;
  text-align: left;
  padding: 0 1em;
}

.tmm {
  width: 20%;
}

@media (max-width: 1200px) {
  .beckertitlename {
    font-size: 2rem;
  }
  .subjecttable {
    width: 100%;
    justify-content: center;
  }
  .stepinfo {
    width: 80%;
  }
}
.subjecttable ul li span {
  float: left;
  text-align: center;
}

.subjecttable ul li {
  padding: 1.2em 0;
  clear: both;
  list-style-type: none;
  overflow: hidden;
}

.subjecttable ul {
  padding: 0;
}

.subjecttable .subpic {
  width: 400px;
  height: 550px;
  padding: 0 2rem 0 2rem;
  object-fit: cover;
}

.barli ul li {
  list-style-type: disc;
  background-color: #fff;
  overflow: visible;
  text-align: left;
  padding: 0px 5px 5px 5px;
}

.barli ul {
  margin: 30px;
}

.detexct {
  width: 70%;
  margin: 60px;
  text-align: center;
}

/* 考試時間與成績保留原則 */
.examtimeline ul {
  padding: 0;
}

.base-timeline {
  list-style-type: none;
  position: relative;
  display: block;
  z-index: 2;
  width: 50%; /* change or remove*/
}

.base-timeline::before {
  content: "";
  width: 100%;
  border-top: 2px solid #2B418E;
  display: inline-block;
  position: absolute;
  top: 50%;
  z-index: -1;
}

.base-timeline__item {
  position: relative;
  display: inline-block;
  width: calc(33.3333333333% + 98px); /* change width */
}

.base-timeline__item::before {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #2B418E;
  color: white;
  font-weight: bold;
  transition: all 0.6s ease-in-out;
  box-sizing: border-box;
}

/* hover element */
.base-timeline__item:hover::before {
  background-color: var(--primary_color);
  transform: scale(1.5);
}

.base-timeline__item--active::before {
  background-color: var(--primary_color);
  border: 2px solid;
  border-color: rgba(0, 0, 0, 0.3);
}

.base-timeline__item:last-child {
  width: 0;
}

.base-timeline__summary-text {
  position: absolute;
  bottom: -4rem;
  left: 9px;
  white-space: nowrap;
}

.base-timeline__item--data::before {
  content: attr(data-step);
  width: 80px;
  height: 80px;
}

/* step */
.step {
  align-items: center;
}

.stepcircle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  color: white;
  text-align: center;
  font-weight: 700;
  padding: 75px 0;
  font-size: 1.2rem;
}

.tsbox {
  background-color: #f7f7f7;
  max-width: 1000px;
  margin: 100px auto;
  padding: 0;
  text-align: center;
}

.tsti {
  background-color: #333;
  color: #fff;
}

.tsbox li {
  padding: 1.2em 0;
  clear: both;
  list-style-type: none;
  overflow: hidden;
}

.tsbox li span {
  width: 20%;
  display: block;
  float: left;
}

/* 雙照計畫 */
.douicon {
  margin: auto;
  justify-content: space-evenly;
  margin-bottom: 100px;
}

.douicon img {
  width: 200px;
}

.doupic {
  width: 100%;
  justify-content: space-evenly;
}

.doupic img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

@media (max-width: 1200px) {
  .doupic img {
    margin-bottom: 2rem;
  }
  .doupic {
    width: 100%;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
  }
  .doupictext {
    width: 80%;
    object-fit: cover;
  }
}
/* 考試花費成本 */
/* 證照互認協議 */
.protocol {
  width: 100%;
  text-align: center;
}

.protocol img {
  border-radius: 50%;
  width: 400px;
  height: 400px;
  object-fit: cover;
}

.ctl {
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #333;
}

.ctbox {
  text-align: center;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #333;
  margin: 2em 0 0 0;
  padding: 0.8em 0;
}

.ctbox img {
  width: 80%;
  clear: both;
  margin: 0 auto;
  display: block;
}

.ctbk {
  width: 75%;
  margin: 0 auto 3em auto;
}

/* === Mobile: 單排橫向滑動（保持橫幅排列）=== */
@media (max-width: 768px) {
  .servicenavbar {
    /* 原本有 flex-wrap: wrap; 改成單排 + 橫向卷軸 */
    flex-wrap: nowrap;
    justify-content: flex-start; /* 從左開始排 */
    gap: 12px;
    padding: 0 12px 12px;
    top: 0; /* 避免 -100px 造成遮擋 */
    overflow-x: auto; /* 允許左右滑 */
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory; /* 滑到卡片會吸附 */
    touch-action: pan-x; /* 手勢優先水平捲動 */
  }
  /* 每個 Link 變成不可換行的滑動項目 */
  .servicenavbar > a {
    flex: 0 0 auto; /* 不要被壓縮、也不要換行 */
    text-decoration: none;
  }
  /* 卡片縮到合宜尺寸，仍可點擊 */
  .servicesq {
    width: 100px;
    height: 100px;
    font-size: clamp(18px, 6vw, 28px);
    border-radius: 16px;
    scroll-snap-align: start; /* 配合上面的 snap */
    /* 若要更小的字可再調整上面 clamp 的值 */
  }
  .secsub {
    font-size: clamp(12px, 3.5vw, 16px);
  }
  /* 隱藏卷軸（可選） */
  .servicenavbar::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 768px) {
  /* Banner：滿版顯示，關掉疊字 */
  .banner img {
    width: 100%;
    height: auto;
    display: block;
  }
  .cpabannertext {
    display: none !important;
  }
  /* Service Navbar：單排橫向滑動（保留橫幅） */
  .servicenavbar {
    flex-wrap: nowrap;
    justify-content: flex-start;
    gap: 12px;
    padding: 0 12px 12px;
    top: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    touch-action: pan-x;
  }
  .servicenavbar > a {
    flex: 0 0 auto;
  }
  .servicesq {
    width: clamp(140px, 44vw, 200px);
    height: clamp(140px, 44vw, 200px);
    font-size: clamp(18px, 6vw, 28px);
    border-radius: 16px;
    scroll-snap-align: start;
  }
  .secsub {
    font-size: clamp(12px, 3.5vw, 16px);
  }
  /* 次導覽（原本 600px 以下隱藏），手機改為可滑動 pills */
  .cpasubnav {
    display: flex !important;
    gap: 12px;
    padding: 16px 12px 24px;
    margin-bottom: 24px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .cpasubnav a div {
    white-space: nowrap;
  }
  /* Why USCPA 方塊：兩欄或直欄 */
  .whycpa {
    gap: 12px;
  }
  .sixsq {
    min-height: 220px;
    padding: 16px;
    border-radius: 16px;
  }
  .sixsq img {
    width: 96px;
    height: 96px;
    margin: auto;
  }
  /* USCPA 生涯規劃卡：改直向、拿掉 hover 動畫 */
  .cpaappliancearea {
    flex-direction: column !important;
    gap: 16px;
    align-items: stretch !important;
  }
  .cpaappliance {
    width: 100%;
    height: auto;
    min-height: 260px;
  }
  .cpaappliance:before {
    height: 100%;
  }
  .cpaappliance:after {
    display: none;
  }
  .sqcontent {
    padding: 24px;
    transform: none !important;
  }
  .sqcontent > * {
    opacity: 1 !important;
    transform: none !important;
  }
  /* 考試科目表：單欄寬版 */
  .examtable {
    grid-template-columns: 1fr !important;
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    gap: 16px;
  }
  .examsubjects {
    padding: 16px;
  }
  .examsubjects img {
    width: 80px;
    height: auto;
  }
  /* 各科架構：改直向，左圖隱藏（你已用 .dis，也再保險一次） */
  .subjecttable {
    flex-direction: column;
    gap: 16px;
    width: 100% !important;
  }
  .subjecttable .col-4, .subjecttable .subpic {
    display: none !important;
  }
  .subjecttable .col-8 {
    width: 100% !important;
  }
  /* 讓列表更好讀 */
  .tms, .tml, .tmm {
    display: inline-block;
    width: auto;
  }
  /* 大表格橫向捲動（考試花費） */
  .table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  /* 協議/圖示區塊緊縮 */
  .protocol img {
    width: 240px;
    height: 240px;
  }
  .douicon {
    flex-direction: column;
    gap: 16px;
  }
  .douicon .col-6 {
    width: 100%;
  }
  /* 其他間距 */
  .beckertitlename {
    margin: 48px 0 !important;
  }
}
/* 修正：協議圖示避免變形（保持原始比例） */
.ctbox .ct-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center; /* 文字置中 */
}

.ctbox .ct-content img {
  /* 清掉可能的全域寬高限制 */
  width: auto !important;
  height: auto !important;
  /* 只限制最大範圍，維持比例縮放 */
  max-width: 80%;
  max-height: 120px;
  object-fit: contain; /* 內容完整顯示，不裁切、不拉伸 */
  display: block;
  margin: 0 auto;
}

/* 行動裝置再縮小一點，避免擠版 */
@media (max-width: 768px) {
  .ctbox .ct-content img {
    max-width: 70%;
    max-height: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cpa/styles/cpa.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,QAAA;AACA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAEJ;;AAAA;EACI,eAAA;AAGJ;;AAAA;EACI;IACI,YAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;EAGN;EADE;IACI,eAAA;EAGN;AACF;AACA,cAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AACA;EACI;IACI,aAAA;EAEN;AACF;AAAA;EACI,qBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,qBAAA;EACA,cAAA;AAGJ;;AADA;EACI,qBAAA;EACA,cAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,cAAA;AAKJ;;AAHA;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAMJ;;AAJA;EACI,YAAA;EACA,aAAA;EACA,sCAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAOJ;;AALA;EACI,YAAA;EACA,aAAA;AAQJ;;AALA;EACI;IACI,mBAAA;EAQN;AACF;AALA,oBAAA;AAEA;EACI,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kKAAA;AAMJ;AALI;EACI,YAAA;AAOR;;AAJA;EACI;IACI,mBAAA;IACA,sBAAA;IACA,WAAA;EAON;AACF;AALA;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAOJ;;AAJA;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAOJ;;AALA;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAQJ;;AANA;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AASJ;;AAPA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAUJ;;AAPA;EACI,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAUJ;;AARA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,mDAAA;EACA,oBAAA;AAWJ;;AATA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,ieAAA;EACA,2BAAA;EACA,iDAAA;AAYJ;;AAVA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,uCAAA;EACA,UAAA;AAaJ;;AAVA;EACI;IACI,wBAAA;EAaN;EAVE;IACI,yCAAA;EAYN;EAVE;IACI,UAAA;IACA,2BAAA;IACA,kEAAA;EAYN;EAVE;;IAEI,mBAAA;EAYN;EAVE;;IAEI,0BAAA;EAYN;EAVE;;IAEI,2BAAA;EAYN;EAVE;;IAEI,wBAAA;EAYN;EAVE;;IAEI,UAAA;IACA,wBAAA;IACA,oCAAA;EAYN;EATE;;;IAGI,uBAAA;EAWN;AACF;AARA,cAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AAUJ;;AARA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAWJ;;AARA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAWJ;;AAPE;EACE;IACI,0BAAA;IACA,qBAAA;IACA,iBAAA;IACA,kBAAA;IACA,UAAA;EAUN;AACF;AAPA;EACI,UAAA;AASJ;;AAPA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;AAUJ;;AARA;EACI,eAAA;EACA,mBAAA;EACA,YAAA;AAWJ;;AATA;EACI,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAYJ;;AAVA;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAaJ;;AAXA;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAcJ;;AAZA;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AAeJ;;AAbA;EACI,cAAA;EACA,WAAA;AAgBJ;;AAdA;EACI,UAAA;AAiBJ;;AAfA;EACI,gBAAA;EACA,0DAAA;EACA,WAAA;AAkBJ;;AAhBA;EACI,UAAA;EACA,iBAAA;AAmBJ;;AAjBA;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;AAoBJ;;AAlBA,YAAA;AACA;EACI,yBAAA;AAqBJ;;AAnBA;EACI,yBAAA;AAsBJ;;AApBA;EACI,yBAAA;AAuBJ;;AArBA;EACI,yBAAA;AAwBJ;;AAtBA;EACI,yBAAA;AAyBJ;;AAvBA;EACI,yBAAA;AA0BJ;;AAxBA;EACI,yBAAA;AA2BJ;;AAzBA;EACI,yBAAA;AA4BJ;;AA1BA;EACI,yBAAA;AA6BJ;;AA3BA;EACI,yBAAA;AA8BJ;;AA5BA;EACI,yBAAA;AA+BJ;;AA7BA;EACI,yBAAA;AAgCJ;;AA9BA;EAAM,yBAAA;AAkCN;;AAjCA;EAAM,yBAAA;AAqCN;;AApCA;EAAM,yBAAA;AAwCN;;AAvCA;EAAO,yBAAA;AA2CP;;AA1CA;EAAO,yBAAA;AA8CP;;AA7CA;EAAO,yBAAA;AAiDP;;AAhDA;EAAO,yBAAA;AAoDP;;AAnDA;EAAO,yBAAA;AAuDP;;AAtDA;EAAO,yBAAA;AA0DP;;AAzDA;EACI,sBAAA;AA4DJ;;AA1DA;EACI,yBAAA;AA6DJ;;AA3DA;EACI,sBAAA;EACA,WAAA;AA8DJ;;AA3DA,kBAAA;AACA;EACI,UAAA;EACA,4BAAA;AA8DJ;;AA5DA;EACI,UAAA;AA+DJ;;AA7DA;EACI,UAAA;EACA,gBAAA;EACA,cAAA;AAgEJ;;AA9DA;EACI,UAAA;AAiEJ;;AA9DA;EACI;IACI,eAAA;EAiEN;EA/DE;IACI,WAAA;IACA,uBAAA;EAiEN;EA/DE;IACI,UAAA;EAiEN;AACF;AA/DA;EACI,WAAA;EACA,kBAAA;AAiEJ;;AA/DA;EACI,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AAkEJ;;AAhEA;EACI,UAAA;AAmEJ;;AAjEA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAoEJ;;AAlEA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAqEJ;;AAnEA;EACI,YAAA;AAsEJ;;AApEA;EACI,UAAA;EACA,YAAA;EACA,kBAAA;AAuEJ;;AArEA,gBAAA;AACA;EACI,UAAA;AAwEJ;;AAtEA;EACI,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA,EAAA,oBAAA;AAyEJ;;AAtEA;EACI,WAAA;EACA,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAyEJ;;AArEA;EACI,kBAAA;EACA,qBAAA;EACA,kCAAA,EAAA,iBAAA;AAwEJ;;AArEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBAAA;AAwEJ;;AAtEA,kBAAA;AACA;EACI,sCAAA;EACA,qBAAA;AAyEJ;;AAtEA;EACI,sCAAA;EACA,iBAAA;EACA,gCAAA;AAyEJ;;AAtEA;EACI,QAAA;AAyEJ;;AAtEA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAyEJ;;AAvEA;EACI,wBAAA;EACA,WAAA;EACA,YAAA;AA0EJ;;AAxEA,SAAA;AACA;EACI,mBAAA;AA2EJ;;AAzEA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA4EJ;;AA1EA;EACI,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AA6EJ;;AA3EA;EACI,sBAAA;EACA,WAAA;AA8EJ;;AA5EA;EACI,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AA+EJ;;AA7EA;EACI,UAAA;EACA,cAAA;EACA,WAAA;AAgFJ;;AA9EA,SAAA;AACA;EACI,YAAA;EACA,6BAAA;EACA,oBAAA;AAiFJ;;AA/EA;EACI,YAAA;AAkFJ;;AAhFA;EACI,WAAA;EACA,6BAAA;AAmFJ;;AAjFA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;AAoFJ;;AAlFA;EACI;IACI,mBAAA;EAqFN;EAnFE;IACI,WAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EAqFN;EAnFE;IACI,UAAA;IACA,iBAAA;EAqFN;AACF;AAnFA,WAAA;AAEA,WAAA;AACA;EACA,WAAA;EACA,kBAAA;AAoFA;;AAjFA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAoFJ;;AAlFA;EACI,sBAAA;EACA,wBAAA;EACA,uBAAA;AAqFJ;;AAnFA;EACI,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AAsFJ;;AApFA;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAuFJ;;AArFA;EACI,UAAA;EACA,uBAAA;AAwFJ;;AArFA,kCAAA;AACA;EACI;IACE,qCAAA;IACA,iBAAA;IACA,2BAAA,EAAA,UAAA;IACA,SAAA;IACA,oBAAA;IACA,MAAA,EAAA,mBAAA;IACA,gBAAA,EAAA,UAAA;IACA,kBAAA;IACA,iCAAA;IACA,6BAAA,EAAA,YAAA;IACA,mBAAA,EAAA,aAAA;EAwFJ;EArFE,wBAAA;EACA;IACE,cAAA,EAAA,gBAAA;IACA,qBAAA;EAuFJ;EApFE,kBAAA;EACA;IACE,YAAA;IACA,aAAA;IACA,iCAAA;IACA,mBAAA;IACA,wBAAA,EAAA,eAAA;IACA,0BAAA;EAsFJ;EAnFE;IACE,mCAAA;EAqFJ;EAlFE,aAAA;EACA;IAAoC,aAAA;EAqFtC;AACF;AApFE;EACE,qBAAA;EACA;IAAc,WAAA;IAAa,YAAA;IAAc,cAAA;EAyF3C;EAxFE;IAAiB,wBAAA;EA2FnB;EAzFE,gCAAA;EACA;IACE,iBAAA;IACA,2BAAA;IACA,SAAA;IACA,oBAAA;IACA,MAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;IACA,6BAAA;IACA,mBAAA;EA2FJ;EAzFE;IAAqB,cAAA;EA4FvB;EA3FE;IACE,gCAAA;IACA,iCAAA;IACA,iCAAA;IACA,mBAAA;IACA,wBAAA;EA6FJ;EA3FE;IAAS,mCAAA;EA8FX;EA5FE,qCAAA;EACA;IACE,wBAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,iCAAA;EA8FJ;EA5FE;IAAkB,mBAAA;EA+FpB;EA7FE,uBAAA;EACA;IAAS,SAAA;EAgGX;EA/FE;IACE,iBAAA;IACA,aAAA;IACA,mBAAA;EAiGJ;EA9FE;IAAY,WAAA;IAAa,YAAA;IAAc,YAAA;EAmGzC;EAjGE,gCAAA;EACA;IACE,iCAAA;IACA,SAAA;IACA,+BAAA;EAmGJ;EAjGE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAmGJ;EAjGE;IAAsB,YAAA;EAoGxB;EAnGE;IAAqB,aAAA;EAsGvB;EArGE;IACE,aAAA;IACA,0BAAA;EAuGJ;EArGE;IAAgB,qBAAA;IAAuB,0BAAA;EAyGzC;EAvGE,eAAA;EACA;IACE,qCAAA;IACA,sBAAA;IACA,yBAAA;IACA,0BAAA;IACA,SAAA;EAyGJ;EAvGE;IAAe,aAAA;EA0GjB;EAzGE;IAAmB,WAAA;IAAa,YAAA;EA6GlC;EA3GE,mCAAA;EACA;IAAe,sBAAA;IAAwB,SAAA;IAAW,sBAAA;EAgHpD;EA/GE;IAA6C,wBAAA;EAkH/C;EAjHE;IAAsB,sBAAA;EAoHxB;EAnHE,WAAA;EACA;IAAkB,qBAAA;IAAuB,WAAA;EAuH3C;EArHE,kBAAA;EACA;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EAuHJ;EApHE,cAAA;EACA;IAAe,YAAA;IAAc,aAAA;EAwH/B;EAvHE;IAAU,sBAAA;IAAwB,SAAA;EA2HpC;EA1HE;IAAiB,WAAA;EA6HnB;EA3HE,SAAA;EACA;IAAkB,yBAAA;EA8HpB;AACF;AA7HE,wBAAA;AACF;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA,EAAA,SAAA;AA+HJ;;AA5HE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,cAAA;EACA,iBAAA;EAEA,mBAAA,EAAA,mBAAA;EACA,cAAA;EACA,cAAA;AA6HJ;;AA1HE,mBAAA;AACA;EACE;IACE,cAAA;IACA,gBAAA;EA6HJ;AACF","sourcesContent":["/* CPA */\n.servicenavbar{\n    position: relative;\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    top: -100px;\n    width: 100%;\n}\n\n.servicesq{\n    display: flex;\n    flex-direction: column;\n    width: 250px;\n    height: 250px;\n    background-color: var(--primary_color);\n    color: #ffff;\n    font-size: 5rem;\n    text-align: center;\n    justify-content: center;\n}\n.secsub {\n    font-size: 2rem;\n\n}\n@media (max-width:1200px) {\n    .servicesq {\n        width: 200px;\n        height: 200px;\n        font-size: 2rem;\n        margin-bottom: 1rem;\n    }\n    .secsub {\n        font-size: 1rem;\n\n    }\n}\n\n/* cpaSubNav */\n.cpasubnav {\n    display: flex;\n    font-size: 1rem;\n    justify-content: space-around;\n    padding-bottom: 50px;\n    padding-top: 50px;\n    margin-bottom: 70px;\n    text-align: center;\n    align-items: center;\n}\n@media (max-width:600px) {\n    .cpasubnav {\n        display: none;\n    }\n}\n.cpasubnav a:hover {\n    text-decoration: none;\n    color: #cacaca;\n}\n.cpasubnav a:link {\n    text-decoration: none;\n    color: #ffffff;\n}\n.cpasubnav a:active {\n    text-decoration: none;\n    color: #6e6e6e;\n}\n.cpasubnav a:visited {\n    text-decoration: none;\n    color: #ffffff;\n}\n.whycpa {\n    display: flex;\n    justify-items: center;\n    align-items: center;\n    justify-content: space-around;\n    flex-wrap: wrap;\n}\n.sixsq {\n    width: 300px;\n    height: 300px;\n    background-color: var(--primary_color);\n    color: #ffff;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n.sixsq img {\n    width: 180px;\n    height: 180px;\n    \n}\n@media (max-width:1200px) {\n    .sixsq {\n        margin-bottom: 2rem;\n    }\n}\n\n/* USCPA 有助生涯&職涯規劃 */\n// 滑鼠hover特效\n.cpaappliance {\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n    width: 250px;\n    height: 400px;\n    overflow: hidden;\n    border-radius: 1.5rem;\n    margin-bottom: 50px;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3), 0 2px 2px rgba(0, 0, 0, 0.3), 0 4px 4px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.3), 0 16px 16px rgba(0, 0, 0, 0.3);\n    img{\n        width: 400px;\n    }\n}\n@media (max-width:1200px) {\n    .cpaappliancearea {\n        align-items: center;\n        flex-direction: column;\n        width: 100%;\n    }\n}\n.cpaappliance:nth-child(1):before {\n    background-image: url(../../../../public/cpaImg/cpa_1.jpg);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.cpaappliance:nth-child(2):before {\n    background-image: url(../../../../public/cpaImg/cpa_2.jpg);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.cpaappliance:nth-child(3):before {\n    background-image: url(../../../../public/cpaImg/cpa_3.jpg);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.cpaappliance:nth-child(4):before {\n    background-image: url(../../../../public/cpaImg/cpa_4.jpg);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.sqtitle {\n    font-size: 2rem;\n    font-weight: bold;\n    line-height: 1.2;\n    text-align: left;\n    color: #ffffff;\n}\n\n.sqdes {\n    font-family: var(--font-serif);\n    font-size: 1rem;\n    font-style: italic;\n    line-height: 1.35;\n    text-align: left;\n    margin-top: 30px;\n    color: #ffffff;\n}\n.cpaappliance:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 110%;\n    background-size: cover;\n    background-position: 0 0;\n    transition: transform calc(var(--f) * 1.5) var(--g);\n    pointer-events: none;\n}\n.cpaappliance:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 200%;\n    pointer-events: none;\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.009) 11.7%, rgba(0, 0, 0, 0.034) 22.1%, rgba(0, 0, 0, 0.072) 31.2%, rgba(0, 0, 0, 0.123) 39.4%, rgba(0, 0, 0, 0.182) 46.6%, rgba(0, 0, 0, 0.249) 53.1%, rgba(0, 0, 0, 0.32) 58.9%, rgba(0, 0, 0, 0.394) 64.3%, rgba(0, 0, 0, 0.468) 69.3%, rgba(0, 0, 0, 0.54) 74.1%, rgba(0, 0, 0, 0.607) 78.8%, rgba(0, 0, 0, 0.668) 83.6%, rgba(0, 0, 0, 0.721) 88.7%, rgba(0, 0, 0, 0.762) 94.1%, rgba(0, 0, 0, 0.79) 100%);\n    transform: translateY(-50%);\n    transition: transform calc(var(--f) * 2) var(--g);\n}\n.sqcontent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items:center;\n    width: 100%;\n    padding: 125px 50px 50px 50px;\n    transition: transform var(--f) var(--g);\n    z-index: 1;\n}\n\n@media (hover: hover) and (min-width: 600px) {\n    .cpaappliance:after {\n        transform: translateY(0);\n    }\n\n    .sqcontent {\n        transform: translateY(calc(100% - 15rem));\n    }\n    .sqcontent > *:not(.title) {\n        opacity: 0;\n        transform: translateY(1rem);\n        transition: transform var(--f) var(--g), opacity var(--f) var(--g);\n    }\n    .cpaappliance:hover,\n    .cpaappliance:focus-within {\n        align-items: center;\n    }\n    .cpaappliance:hover:before,\n    .cpaappliance:focus-within:before {\n        transform: translateY(-4%);\n    }\n    .cpaappliance:hover:after,\n    .cpaappliance:focus-within:after {\n        transform: translateY(-50%);\n    }\n    .cpaappliance:hover .sqcontent,\n    .cpaappliance:focus-within .sqcontent {\n        transform: translateY(0);\n    }\n    .cpaappliance:hover .sqcontent > *:not(.title),\n    .cpaappliance:focus-within .sqcontent > *:not(.title) {\n        opacity: 1;\n        transform: translateY(0);\n        transition-delay: calc(var(--f) / 8);\n    }\n\n    .cpaappliance:focus-within:before, .card:focus-within:after,\n    .cpaappliance:focus-within .sqcontent,\n    .cpaappliance:focus-within .sqcontent > *:not(.title) {\n        transition-duration: 0s;\n    }\n}\n\n/* 考試科目與題型配比 */\n.examtable {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.examsubjects {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: center;\n    color: #ffff;\n}\n\n.examtable {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 30px;\n    margin-bottom: 80px;\n  }\n  \n \n  @media (max-width: 1200px) {\n    .examtable {\n        grid-template-columns: 1fr;\n        align-content: center;\n        margin-left: auto;\n        margin-right: auto;\n        width: 75%;\n\n    }\n  }\n.examsubjects img {\n    width: 30%;\n}\n.subjectname{\n    font-size: 1.4rem;\n    font-weight: 700;\n    line-height: 4rem;\n}\n.fullname {\n    font-size: 1rem;\n    line-height: 1.4rem;\n    height: 2rem;\n}\n.chmean {\n    font-size: 1rem;\n    line-height: 1.4rem;\n    height: 4rem;\n    margin: 0 8%;\n}\n.des {\n    font-size: 1rem;\n    line-height: 1.4rem;\n    margin:0 10% 10% 10%;\n    text-align: center;\n}\n.examtime {\n    font-size: 1rem;\n    text-align: center;\n    line-height: 3rem;\n    height: 3rem;\n    width: 100%;\n}\n.qutype {\n    width: 100%;\n    line-height: 1.8rem;\n    height: 11rem;\n    font-size: 1rem;\n    padding: 1rem;\n}\n.qutype span {\n    display: block;\n    float: left;\n}\n.qutype ul {\n    padding: 0;\n}\n.qutype li {\n    list-style: none;\n    border-bottom: #ffffff4b 1px solid;\n    clear: both;\n}\n.qutype li .mma {\n    width: 80%;\n    padding-right: 5%;\n}\n.qutype li .mmt {\n    width: 15%;\n    text-align: right;\n    margin-right: 5%;\n}\n/* bgcolor */\n.fr {\n    background-color: #0c4a83\n}\n.tfr {\n    background-color: #0a4072;\n}\n.mfr {\n    background-color: #072c4e;\n}\n.bc {\n    background-color: #ff8546;\n}\n.tbc {\n    background-color: #ff732b;\n}\n.mbc {\n    background-color: #ff6211;\n}\n.rg {\n    background-color: #866579;\n}\n.trg {\n    background-color: #69505f;\n}\n.mrg {\n    background-color: #4d3a45;\n}\n.au {\n    background-color: #d96939;\n}\n.tau {\n    background-color: #b1562f;\n}\n.mau {\n    background-color: #884224;\n}\n.br { background-color: #1f6e84;}\n.ic { background-color: #e09428;}\n.tp { background-color: #a647a5;}\n.tbr { background-color: #1a5c6e;}\n.tic { background-color: #c48123;}\n.ttp { background-color: #883987;}\n.mbr { background-color: #123e4b;}\n.mic { background-color: #a16a1d;}\n.mtp { background-color: #692d68;}\n.wt {\n    background-color: #fff;\n}\n.gr {\n    background-color: #f7f7f7;\n}\n.tsti {\n    background-color: #333;\n    color: #fff;\n}\n\n/* 四科考試架構及考試注意事項 */\n.tmxl {\n    width: 80%;\n    border-right: 1px solid #fff;\n}\n.tms {\n    width: 15%;\n}\n.tml {\n    width: 45%;\n    text-align: left;\n    padding: 0 1em;\n}\n.tmm {\n    width: 20%;\n}\n\n@media (max-width:1200px) {\n    .beckertitlename {\n        font-size: 2rem;\n    }\n    .subjecttable{\n        width: 100%;\n        justify-content: center;\n    }\n    .stepinfo {\n        width: 80%;\n    }\n}\n.subjecttable ul li span{\n    float: left;\n    text-align: center;\n}\n.subjecttable ul li {\n    padding: 1.2em 0;\n    clear: both;\n    list-style-type: none;\n    overflow: hidden;\n}\n.subjecttable ul {\n    padding: 0;\n}\n.subjecttable .subpic {\n    width: 400px;\n    height: 550px;\n    padding: 0 2rem 0 2rem;\n    object-fit: cover;\n}\n.barli ul li{\n    list-style-type: disc;\n    background-color: #fff;\n    overflow: visible;\n    text-align: left;\n    padding: 0px 5px 5px 5px;\n}\n.barli ul {\n    margin: 30px;\n}\n.detexct{\n    width: 70%;\n    margin: 60px;\n    text-align: center;\n}\n/* 考試時間與成績保留原則 */\n.examtimeline ul {\n    padding: 0;\n}\n.base-timeline {\n    list-style-type: none;\n    position: relative;\n    display: block;\n    z-index: 2;\n    width: 50%; /* change or remove*/\n}\n\n.base-timeline::before {\n    content: '';\n    width: 100%;\n    border-top: 2px solid #2B418E;\n    display: inline-block;\n    position: absolute;\n    top: 50%;\n    z-index: -1;\n\n}\n\n.base-timeline__item {\n    position: relative;\n    display: inline-block;\n    width: calc(100% / 3 - -98px); /* change width */\n}\n\n.base-timeline__item::before {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background-color: #2B418E;\n    color: white;\n    font-weight: bold;\n    transition: all 0.6s ease-in-out;\n    box-sizing: border-box;\n}\n/* hover element */\n.base-timeline__item:hover::before {\n    background-color: var(--primary_color);\n    transform: scale(1.5);\n}\n\n.base-timeline__item--active::before {\n    background-color: var(--primary_color);\n    border: 2px solid;\n    border-color: rgba( 0, 0, 0, .3);\n}\n\n.base-timeline__item:last-child {\n    width: 0;\n}\n\n.base-timeline__summary-text {\n    position: absolute;\n    bottom: -4rem; \n    left:9px;\n    white-space: nowrap;\n}\n.base-timeline__item--data::before {\n    content: attr(data-step);\n    width: 80px;\n    height: 80px;\n}\n/* step */\n.step {\n    align-items: center;\n}\n.stepcircle {\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    color: #ffff;\n    text-align: center;\n    font-weight: 700;\n    padding: 75px 0;\n    font-size: 1.2rem;\n}\n.tsbox {\n    background-color: #f7f7f7;\n    max-width: 1000px;\n    margin: 100px auto;\n    padding: 0;\n    text-align: center;\n}\n.tsti {\n    background-color: #333;\n    color: #fff;\n}\n.tsbox li {\n    padding: 1.2em 0;\n    clear: both;\n    list-style-type: none;\n    overflow: hidden;\n}\n.tsbox li span {\n    width: 20%;\n    display: block;\n    float: left;\n}\n/* 雙照計畫 */\n.douicon {\n    margin: auto;\n    justify-content: space-evenly;\n    margin-bottom: 100px;\n}\n.douicon img {\n    width: 200px;\n}\n.doupic {\n    width: 100%;\n    justify-content: space-evenly;\n}\n.doupic img {\n    width: 200px;\n    height: 200px;\n    object-fit: cover;\n}\n@media (max-width:1200px) {\n    .doupic img{\n        margin-bottom: 2rem;\n    }\n    .doupic{\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 2rem;\n    }\n    .doupictext {\n        width: 80%;\n        object-fit: cover;\n    }\n}\n/* 考試花費成本 */\n\n/* 證照互認協議 */\n.protocol {\nwidth: 100%;\ntext-align: center;\n\n}\n.protocol img {\n    border-radius: 50%;\n    width: 400px;\n    height: 400px;\n    object-fit: cover;\n}\n.ctl {\n    border-left-width: 1px;\n    border-left-style: solid;\n    border-left-color: #333;\n}\n.ctbox {\n    text-align: center;\n    border-right-width: 1px;\n    border-right-style: solid;\n    border-right-color: #333;\n    margin: 2em 0 0 0;\n    padding: 0.8em 0;\n}\n.ctbox img {\n    width: 80%;\n    clear: both;\n    margin: 0 auto;\n    display: block;\n}\n.ctbk {\n    width: 75%;\n    margin: 0 auto 3em auto;\n}\n\n/* === Mobile: 單排橫向滑動（保持橫幅排列）=== */\n@media (max-width: 768px) {\n    .servicenavbar{\n      /* 原本有 flex-wrap: wrap; 改成單排 + 橫向卷軸 */\n      flex-wrap: nowrap;\n      justify-content: flex-start;     /* 從左開始排 */\n      gap: 12px;\n      padding: 0 12px 12px;\n      top: 0;                          /* 避免 -100px 造成遮擋 */\n      overflow-x: auto;                /* 允許左右滑 */\n      overflow-y: hidden;\n      -webkit-overflow-scrolling: touch;\n      scroll-snap-type: x mandatory;   /* 滑到卡片會吸附 */\n      touch-action: pan-x;             /* 手勢優先水平捲動 */\n    }\n  \n    /* 每個 Link 變成不可換行的滑動項目 */\n    .servicenavbar > a {\n      flex: 0 0 auto;                  /* 不要被壓縮、也不要換行 */\n      text-decoration: none;\n    }\n  \n    /* 卡片縮到合宜尺寸，仍可點擊 */\n    .servicesq{\n      width: 100px;\n      height: 100px;\n      font-size: clamp(18px, 6vw, 28px);\n      border-radius: 16px;\n      scroll-snap-align: start;        /* 配合上面的 snap */\n      /* 若要更小的字可再調整上面 clamp 的值 */\n    }\n  \n    .secsub{\n      font-size: clamp(12px, 3.5vw, 16px);\n    }\n  \n    /* 隱藏卷軸（可選） */\n    .servicenavbar::-webkit-scrollbar { display: none; }\n  }\n  @media (max-width: 768px) {\n    /* Banner：滿版顯示，關掉疊字 */\n    .banner img { width: 100%; height: auto; display: block; }\n    .cpabannertext { display: none !important; }\n  \n    /* Service Navbar：單排橫向滑動（保留橫幅） */\n    .servicenavbar{\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      gap: 12px;\n      padding: 0 12px 12px;\n      top: 0;\n      overflow-x: auto;\n      overflow-y: hidden;\n      -webkit-overflow-scrolling: touch;\n      scroll-snap-type: x mandatory;\n      touch-action: pan-x;\n    }\n    .servicenavbar > a { flex: 0 0 auto; }\n    .servicesq{\n      width: clamp(140px, 44vw, 200px);\n      height: clamp(140px, 44vw, 200px);\n      font-size: clamp(18px, 6vw, 28px);\n      border-radius: 16px;\n      scroll-snap-align: start;\n    }\n    .secsub{ font-size: clamp(12px, 3.5vw, 16px); }\n  \n    /* 次導覽（原本 600px 以下隱藏），手機改為可滑動 pills */\n    .cpasubnav{\n      display: flex !important;\n      gap: 12px;\n      padding: 16px 12px 24px;\n      margin-bottom: 24px;\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n    .cpasubnav a div{ white-space: nowrap; }\n  \n    /* Why USCPA 方塊：兩欄或直欄 */\n    .whycpa{ gap: 12px; }\n    .sixsq{\n      min-height: 220px;\n      padding: 16px;\n      border-radius: 16px;\n      \n    }\n    .sixsq img{ width: 96px; height: 96px; margin: auto;}\n  \n    /* USCPA 生涯規劃卡：改直向、拿掉 hover 動畫 */\n    .cpaappliancearea{\n      flex-direction: column !important;\n      gap: 16px;\n      align-items: stretch !important;\n    }\n    .cpaappliance{\n      width: 100%;\n      height: auto;\n      min-height: 260px;\n    }\n    .cpaappliance:before{ height: 100%; }\n    .cpaappliance:after{ display: none; }\n    .sqcontent{\n      padding: 24px;\n      transform: none !important;\n    }\n    .sqcontent > *{ opacity: 1 !important; transform: none !important; }\n  \n    /* 考試科目表：單欄寬版 */\n    .examtable{\n      grid-template-columns: 1fr !important;\n      width: 100% !important;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n      gap: 16px;\n    }\n    .examsubjects{ padding: 16px; }\n    .examsubjects img{ width: 80px; height: auto; }\n  \n    /* 各科架構：改直向，左圖隱藏（你已用 .dis，也再保險一次） */\n    .subjecttable{ flex-direction: column; gap: 16px; width: 100% !important; }\n    .subjecttable .col-4, .subjecttable .subpic{ display: none !important; }\n    .subjecttable .col-8{ width: 100% !important; }\n    /* 讓列表更好讀 */\n    .tms, .tml, .tmm{ display: inline-block; width: auto; }\n  \n    /* 大表格橫向捲動（考試花費） */\n    .table{\n      display: block;\n      overflow-x: auto;\n      white-space: nowrap;\n    }\n  \n    /* 協議/圖示區塊緊縮 */\n    .protocol img{ width: 240px; height: 240px; }\n    .douicon{ flex-direction: column; gap: 16px; }\n    .douicon .col-6{ width: 100%; }\n  \n    /* 其他間距 */\n    .beckertitlename{ margin: 48px 0 !important; }\n  }\n  /* 修正：協議圖示避免變形（保持原始比例） */\n.ctbox .ct-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center; /* 文字置中 */\n  }\n  \n  .ctbox .ct-content img {\n    /* 清掉可能的全域寬高限制 */\n    width: auto !important;\n    height: auto !important;\n  \n    /* 只限制最大範圍，維持比例縮放 */\n    max-width: 80%;\n    max-height: 120px;\n  \n    object-fit: contain;   /* 內容完整顯示，不裁切、不拉伸 */\n    display: block;\n    margin: 0 auto;\n  }\n  \n  /* 行動裝置再縮小一點，避免擠版 */\n  @media (max-width: 768px) {\n    .ctbox .ct-content img {\n      max-width: 70%;\n      max-height: 90px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
